/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

import { Span } from '@opentelemetry/api'

import { setNumberAttribute } from '../../utils/span-attributes'
import { LayoutShiftRect } from './types'

export function setRectAttributes(span: Span, prefix: string, rect: LayoutShiftRect | undefined): void {
	if (!rect) {
		return
	}

	setNumberAttribute(span, `${prefix}.x`, rect.x)
	setNumberAttribute(span, `${prefix}.y`, rect.y)
	setNumberAttribute(span, `${prefix}.width`, rect.width)
	setNumberAttribute(span, `${prefix}.height`, rect.height)
}
